import { LineItem } from '../LineItem';

const TYPE = 'QuickQuote';

export class QuickQuoteLineItem extends LineItem {
  pickupStopSequenceNumber = 1;
  dropOffStopSequenceNumber = 2;

  constructor(opts?: Partial<QuickQuoteLineItem>) {
    super(opts);
    this.type = TYPE;
  }

  static isQuickQuoteLineItem(
    lineItem: LineItem,
  ): lineItem is QuickQuoteLineItem {
    return lineItem.type === TYPE;
  }
}
